import { createSelector } from 'reselect';
import { RootState } from 'store/types';
import orderBy from 'lodash/orderBy';

export const proceduresSelector = (state: RootState) => state.procedures.procedures;

export const proceduresLoadingSelector = createSelector(
  proceduresSelector,
  procedures => procedures.loading
);

export const proceduresDataSelector = createSelector(proceduresSelector, procedures =>
  orderBy(procedures.data, ['datePerformed'], ['desc'])
);

export const proceduresErrorSelector = createSelector(
  proceduresSelector,
  procedures => procedures.error
);

export const proceduresRequestStateSelector = createSelector(
  proceduresSelector,
  procedures => procedures.requestState
);

/**
 * Share Procedures
 */
export const shareProceduresSelector = (state: RootState) => state.procedures.shareProcedures;

export const shareProceduresSendingSelector = createSelector(
  shareProceduresSelector,
  shareProcedures => shareProcedures.isSendingProcedures
);

export const shareProceduresDataSelector = createSelector(
  shareProceduresSelector,
  shareProcedures => shareProcedures.sharedProceduresData
);

/**
 * Download Procedures
 */
export const proceduresDownloadsSelector = (state: RootState) =>
  state.procedures.downloadProcedures;

export const proceduresDownloadingSelector = createSelector(
  proceduresDownloadsSelector,
  downloadProcedures => downloadProcedures.isDownloading
);
